import {
    SET_LOADING,
    SET_LOCALE,
    SET_CONFIG,
    SET_GLOBAL_CONFIG,
    SET_MODULE,
    SET_MODULE_NAME,
    SET_APPLICATION_CODE,
    SET_PANEL,
    SET_CUSTOM_SETTINGS_MODULE,

    SET_LOADING_MAP,
    SET_CONFIG_MAP,
    SET_ACTION_MAP,
    SET_VIEW_PROJECTION_MAP,

    NAVIGATION_SET_ROUTE,

    BREADCRUMB_SET,

    TOC_SET_SELECTED,

    CATALOG_RECORD_LIST_LOADED,
    CATALOG_RECORD_LIST_LOAD_ERROR,
    CATALOG_CHANGE_SELECTED_SERVICE,
    CATALOG_ADD_CATALOG_SERVICE,
    CATALOG_DELETE_CATALOG_SERVICE,
    CATALOG_CHANGE_CATALOG_MODE,
    CATALOG_INITED,
    CATALOG_SET_LOADING,
    CATALOG_SAVING_SERVICE,
    CATALOG_CHANGE_TEXT,
    CATALOG_ADD_LAYER_FROM_CATALOGS,

    IDENTIFY_SET_LOADING,
    IDENTIFY_CHANGE_PAGE,
    IDENTIFY_NEW_REQUEST,
    IDENTIFY_PURGE_RESULTS,
    IDENTIFY_ERROR_FEATURE_INFO,
    IDENTIFY_EXCEPTIONS_FEATURE_INFO,
    IDENTIFY_LOAD_FEATURE_INFO,

    FEATURE_VIEWER_CLOSE,
    FEATURE_VIEWER_SET_LOADING,
    FEATURE_VIEWER_LOADED,
    FEATURE_VIEWER_LOAD_ERROR,

    FEEDBACKOPTIONS_INITIATE,
    FEEDBACKOPTIONS_FINISHED,

    SET_BROADCASTING_ENABLED,
    SET_BROADCASTING_STATE,
    SET_ACTION
} from './mutation-types';

import Vue from 'vue';
import { isObject, isUndefined, mergeDeep, customMergeDeep, isString, setState } from '@config/utils'
import { isIndexValid } from '@/components/maps/shared/catalog/utils/FeatureInfoUtils'
import { convertSettingsUrl } from '@/app/shared/utils/urlUtils';

const mutations = {
    [SET_LOADING](state, flag) {
        state.loading = flag;
    },
    [SET_LOCALE](state, locale = {}) {
        state.locale = Object.assign(state.locale, {...locale});
    },
    [SET_CONFIG](state, config) {
        state.config = config;
    },
    [SET_GLOBAL_CONFIG](state, module) {
        state.data.global = {
            ...state.data.global,
            ... {
                code: module.code,
                applicationCode: module.applicationCode ? module.applicationCode.replace(new RegExp(`(${CITYHUB_MANAGE_SUFFIX}|central)$`), '') : module.applicationCode,
                title: module.name,
                description: module.description,
                keywords: module.keywords,
                theme_color: module.theme_color,
            }
        };
    },
    [SET_CUSTOM_SETTINGS_MODULE](state, { module, themeConfig, config, getters }) {
        // GLOBAL TOOLS
        let isManage = isBackofficeModule(module);
        let globalTools = (isManage ? {} : getters.getTools()) || {};
        let moduleTools = getters.getTools(module);
        customMergeDeepWithoutOverwrite(moduleTools, {...globalTools});

        let ref = {
            tools: {
                keys: [],
                items: [],
            },
            panels: {
                keys: [],
                items: [],
            },
            map: {
                keys: [],
                items: [],
            },
        };

        ref['tools']['items'] = moduleTools;
        ref['tools']['keys'] = Object.keys(ref['tools']['items']);

        ref['panels']['items'] = getters.getPanels(module);
        ref['panels']['keys'] = Object.keys(ref['panels']['items']);

        ref['map']['items'] = getters.getMapDefinitions(module);
        ref['map']['keys'] = Object.keys(ref['map']['items']);

        // APPLY THEME SETTINGS TO VUEX
        if(themeConfig) {
            let tkeys = Object.keys(themeConfig);
            if (!isBackofficeModule(module) && tkeys.includes('tools')) {
                let tools = themeConfig.tools;
                let refKeys = ref['tools']['keys'];
                let refItems = ref['tools']['items'];
                for (const tkey of Object.keys(tools)) {
                    if (refKeys.includes(tkey)) {
                        if (isObject(refItems[tkey])) {
                            if(!refItems[tkey].display){
                                Vue.set(refItems[tkey], 'display', {});
                            }
                            Object.assign(refItems[tkey].display, tools[tkey]);
                        }
                    }
                }
            }
        }

        let cfgPanels = config.panels ?? [];
        cfgPanels = cfgPanels.reduce((accumulator, item) => {
            return { ...accumulator, [item.code.split('.').slice(1).join('.')]: item.val ?? {} };
        }, {});
        let cfgTools = config.tools ?? [];
        cfgTools = cfgTools.reduce((accumulator, item) => {
            return { ...accumulator, [item.code.split('.').slice(1).join('.')]: item.val ?? {} };
        }, {});

        let settings = {
            ...(getters.customSettings || {}),
            ...{panels: cfgPanels},
            ...{tools: cfgTools}
        };

        // GLOBAL Config
        let globalSettings = settings.global ?? {};
        mergeDeep(state.data.global, globalSettings);
        let panelsSettings = settings.panels ?? {};
        mergeDeep(state.data.panels, panelsSettings);
        // MODULE
        let moduleSettings = {...(settings.modules && settings.modules[module] ? settings.modules[module] : {})};
        let skeys = Object.keys(moduleSettings);
        (isManage ? ['panels'] : Object.keys(ref)).forEach(skey => {
            if (skeys.includes(skey)) {
                let items = moduleSettings[skey];
                let itemsKeys = Object.keys(items);
                let refKeys = ref[skey]['keys'];
                let refItems = ref[skey]['items'];
                for (const tkey of itemsKeys) {
                    if (refKeys.includes(tkey)) {
                        if (isObject(refItems[tkey])) {
                            if(!refItems[tkey].display && skey != 'map'){
                                Vue.set(refItems[tkey], 'display', {});
                            }
                            mergeDeep(refItems[tkey], items[tkey]);
                        }
                    }
                }
            }
        });
    },
    [SET_APPLICATION_CODE](state, code) {
        state.data.global.applicationCode = code ? code.replace(new RegExp(`(${CITYHUB_MANAGE_SUFFIX}|central)$`), '') : code;
    },
    [SET_MODULE_NAME](state, name) {
        state.data.global.title = name;
    },
    [SET_MODULE](state, { module, getters }) {
        const moduleCode = module.code_alias || module.code;
        let isManage = isBackofficeModule(moduleCode);
        let settings = module.settings || {};
        let urlSettings = convertSettingsUrl(module.route, {active: true}) || {};
        settings = {...module.settings, ...urlSettings};
        if (settings) {
            let skeys = Object.keys(settings);
            let options = {};
            options.panels = getters.getPanels(moduleCode);
            if(!isManage) {
                options.tools = getters.getTools(moduleCode);
            }
            for (const keyOptions in options) {
                const option = options[keyOptions];

                for (let pkey of Object.keys(option)) {
                    let tool = option[pkey];
                    let panel = tool.panel;
                    let model = tool.model;

                    let skey = model ? skeys.find(k => k == model) : skeys.find(k => k == pkey);
                    if (skey) {
                        if(!panel) continue;

                        let filteredSettings = Object.keys(settings[skey]).filter((k) => {
                            return Object.keys(panel).includes(k);
                        });
                        for (let fkey of filteredSettings) {
                            if (isObject(panel[fkey])) {
                                Object.assign(panel[fkey], settings[skey][fkey]);
                            } else {
                                panel[fkey] = settings[skey][fkey];
                            }
                        }
                    }

                    // if (model) {
                    //     let skey = skeys.find(k => k == model || k == pkey);
                    //     if (skey) {
                    //         let filteredSettings = Object.keys(settings[skey]).filter((k) => {
                    //             return Object.keys(panel).includes(k);
                    //         });
                    //         for (let fkey of filteredSettings) {
                    //             if (isObject(panel[fkey])) {
                    //                 Object.assign(panel[fkey], settings[skey][fkey]);
                    //             } else {
                    //                 panel[fkey] = settings[skey][fkey];
                    //             }
                    //         }
                    //     }
                    // }
                }
            }
        }
        delete module.settings;
        if(moduleCode in state) {
            let tempDataState = state[moduleCode].data;
            // aplicar as configurações globais do map
            let globalMapSettings = state?.data?.map || {};
            if('map' in tempDataState){
                let fullConfig = customMergeDeepWithoutOverwrite(tempDataState.map, {...globalMapSettings});
                Object.assign(tempDataState.map, {...fullConfig});
            }else{
                Vue.set(tempDataState, 'map', globalMapSettings);
            }
            tempDataState.module = module;
            // aplicar as configurações que vêm da API
            if(module.front_configs && module.front_configs.length > 0) {
                module.front_configs.forEach(item => {
                    tempDataState = setState(tempDataState, `${item.path}.active`, item.active);
                    let acls = item.acls;
                    let properties = item.properties;
                    if(acls) {
                        for(const method in acls) {
                            const code = acls[method];
                            tempDataState = setState(tempDataState, `${item.path}.acl.${method}`, code);
                        }
                    }
                    if(properties) {
                        for(const key in properties) {
                            const value = properties[key];
                            tempDataState = setState(tempDataState, `${item.path}.${key}`, value);
                        }
                    }
                });
            }
            state[moduleCode].data = tempDataState;

            if(module.map) {
                let moduleConfigMap = state[moduleCode].data.map && state[moduleCode].data.map.config ?
                    state[moduleCode].data.map.config : {};
                let configMap = module.map;
                for (let mkey of Object.keys(configMap)) {
                    if (isObject(moduleConfigMap[mkey])) {
                        // Object.assign(stateConfigMap[mkey], configMap[mkey]);
                        customMergeDeep(moduleConfigMap[mkey], configMap[mkey]);
                    } else {
                        moduleConfigMap[mkey] = configMap[mkey];
                    }
                }
            }
        }
    },
    [SET_PANEL](state, {getters, id, module, ...params }) {
        let panel = null;
        if(module) {
            panel = getters.getPanel(module, id);
        }else{
            let panels = state.data.panels;
            panel = id in panels ? panels[id] : null;
        }

        if (!panel) {
            return;
        }
        for (var key in params) {
            if (['active', 'show', 'loaded'].includes(key)) {
                params[key] = !!params[key];
            }
            if (panel.hasOwnProperty(key) && params[key] !== undefined) {
                if (isObject(panel[key]) && isObject(params[key])) {
                    panel[key] = {...panel[key], ...params[key] };
                } else {
                    panel[key] = params[key];
                }
            }
        }
    },

    // MAP
    [SET_LOADING_MAP](state, flag) {
        state.data.map.loading = flag;
        if(module in state) {
            let moduleState = state[module].data;
            moduleState = setState(moduleState, `map.loading`, flag);
            state[module].data = moduleState;
        }
    },
    [SET_CONFIG_MAP](state, {module, config }) {
        if(module in state) {
            let moduleState = state[module].data;
            moduleState = setState(moduleState, `map.config`, config);
            state[module].data = moduleState;
            // state.data.map.config = Object.assign(state.data.map.config, config);
        }
    },
    [SET_ACTION_MAP](state, {module, action }) {
        if(module in state) {
            let moduleState = state[module].data;
            moduleState = setState(moduleState, `map.action`, action);
            state[module].data = moduleState;
        }
    },
    [SET_VIEW_PROJECTION_MAP](state, {module, projection }) {
        if(module && module in state) {
            let moduleState = state[module].data;
            moduleState = setState(moduleState, `map.view_projection`, projection);
            state[module].data = moduleState;
        }else{
            state.data.map.view_projection = projection;
        }
    },

    // NAVIGATION
    [NAVIGATION_SET_ROUTE](state, route) {
        state.data.global.navigation.route = route;
    },
    // BREADCRUMB
    [BREADCRUMB_SET](state, { getters, ...params }) {
        params = isString(params) ? {label: params} : params;
        let route = getters.navigationRoute || {};
        let breadcrumb = state.data.panels.breadcrumb || {};
        breadcrumb.label = params.label || route.meta.title;
        breadcrumb.parent = params.parent;
        // update route title with breadcrumb
        route.meta.title = breadcrumb.label;

        let crumbs = []
        let matched = route.matched || [];
        matched.forEach(function (route) {
            let hasBreadcrumb = route.meta && route.meta.title;
            if (hasBreadcrumb) {
                crumbs.push(route);
            }
        });
        breadcrumb.crumbs = crumbs;
    },
    // TOC
    [TOC_SET_SELECTED](state, { getters, idModule, ...params }) {
        // let tool = getters.getTool(idModule, 'layers');
        // if (tool) {
        //     tool.selected = params.selected;
        // }
        let panel = state.data.panels.toclayers;
        panel.selected = params.selected;
    },

    // CATALOG
    [CATALOG_INITED](state, loading) {

    },
    [CATALOG_SET_LOADING](state, {...params }) {
        let panel = state.data.panels.catalog;
        panel.loading = params.loading;
    },
    [CATALOG_SAVING_SERVICE](state, {...params }) {
        let panel = state.data.panels.catalog;
        panel.saving = params.status;
    },
    [CATALOG_CHANGE_SELECTED_SERVICE](state, {...params }) {
        let panel = state.data.panels.catalog;
        Object.assign(panel, params);
    },
    [CATALOG_CHANGE_TEXT](state, {...params }) {
        let panel = state.data.panels.catalog;
        if (!panel.searchOptions) {
            panel.searchOptions = {};
        }
        Object.assign(panel.searchOptions, Object.assign({}, state.searchOptions, {
            text: params.text
        }));
    },
    [CATALOG_RECORD_LIST_LOAD_ERROR](state, {...params }) {
        let panel = state.data.panels.catalog;
        Object.assign(panel, {
            result: null,
            searchOptions: null,
            loadingError: params.error,
            loading: false,
            layerError: null
        });
    },
    [CATALOG_RECORD_LIST_LOADED](state, {...params }) {
        let panel = state.data.panels.catalog;
        Object.assign(panel, {
            result: params.result,
            searchOptions: params.searchOptions,
            loadingError: null,
            layerError: null,
            loading: false
        });
    },
    [CATALOG_CHANGE_CATALOG_MODE](state, {...params }) {
        let panel = state.data.panels.catalog;
        if (params.onlyMode) {
            Object.assign(panel, {
                mode: params.mode,
            });
        } else {
            Object.assign(panel, {
                newService: params.isNew ? panel.emptyService : Object.assign({}, panel.services && panel.services.find(s => s.id == [panel.selectedService || ""]) || {}, { oldService: panel.selectedService || "" }),
                mode: params.mode,
                result: null,
                loadingError: null,
                layerError: null
            });
        }
    },
    [CATALOG_ADD_CATALOG_SERVICE](state, {...params }) {
        let panel = state.data.panels.catalog;
        // this.savingService(true);
        panel.saving = true;
        panel.saving = false;
        // this.savingService(false);
        const { isNew, ...service } = params.service;
        const selectedService = isNew ? service.id : panel.selectedService;
        service.id = selectedService;
        const newServices = panel.services.map(a => Object.assign({}, a));
        if (isNew) {
            newServices.push(service);
        } else {
            let idx = newServices.findIndex(x => x.id == selectedService);
            if (idx !== -1) {
                newServices[idx] = service;
            }
        }
        Object.assign(panel, {
            services: newServices,
            selectedService,
            mode: "view",
            result: null,
            loadingError: null,
            searchOptions: Object.assign({}, state.searchOptions, {
                text: ""
            }),
            layerError: null
        });

        if (panel.services.filter(s => s.id === params.service)) {
            this.$helper.messages.showToast(`O serviço foi ${isNew ? 'adicionado' : 'atualizado'}`, 'Aviso', 'success');
        } else {
            this.$helper.messages.showToast(`Não foi possível ${isNew ? 'adicionar' : 'atualizar'} o serviço`, 'Erro', 'error');
        }

    },
    [CATALOG_DELETE_CATALOG_SERVICE](state, {...params }) {
        let panel = state.data.panels.catalog;

        let selectedService = "";
        let newServices = panel.services.map(a => Object.assign({}, a));
        newServices = newServices.filter(s => s.id !== params.service);
        if (newServices.length) {
            selectedService = newServices[0].id;
        }
        Object.assign(panel, {
            services: newServices,
            selectedService,
            mode: "view",
            result: null,
            loadingError: null,
            layerError: null
        });

        if (panel.services.filter(s => s.id === params.service)) {
            this.$helper.messages.showToast('O serviço foi removido', 'Aviso', 'success');
        } else {
            this.$helper.messages.showToast('Não foi possível remover o serviço', 'Erro', 'error');
        }
    },
    [CATALOG_ADD_LAYER_FROM_CATALOGS](state, {...params }) {
        let panel = state.data.panels.catalog;
    },

    // IDENTIFY
    [IDENTIFY_SET_LOADING](state, {...params }) {
        let panel = state.data.panels.identify;
        panel.loading = params.loading;
    },
    [IDENTIFY_CHANGE_PAGE](state, {...params }) {
        let panel = state.data.panels.identify;
        panel.index = params.index;
    },
    [IDENTIFY_NEW_REQUEST](state, {...params }) {
        let panel = state.data.panels.identify;
        const { reqId, request } = params;
        const requests = panel.requests || [];
        Object.assign(panel, {
            index: undefined,
            requests: [...requests, { request, reqId }]
        });
    },
    [IDENTIFY_PURGE_RESULTS](state, {...params }) {
        let panel = state.data.panels.identify;
        const { selectedLayer, loading, ...others } = panel;
        Object.assign(panel, {
            ...others,
            index: undefined,
            queryableLayers: [],
            responses: [],
            requests: [],
        });
    },
    [IDENTIFY_ERROR_FEATURE_INFO](state, {...params }) {
        let panel = state.data.panels.identify;
        receiveResponseIdentify(panel, params, 'error');
    },
    [IDENTIFY_EXCEPTIONS_FEATURE_INFO](state, {...params }) {
        let panel = state.data.panels.identify;
        receiveResponseIdentify(panel, params, 'exceptions');
        // Object.assign(panel, {
        //     result: null,
        //     searchOptions: null,
        //     loadingError: params.error,
        //     loading: false,
        //     layerError: null
        // });
    },
    [IDENTIFY_LOAD_FEATURE_INFO](state, {...params }) {
        let panel = state.data.panels.identify;
        receiveResponseIdentify(panel, params, 'data')
    },
    // [IDENTIFY_RECORD_LIST_LOAD_ERROR](state, {...params}) {
    //     let panel = state.data.panels.identify;
    //     Object.assign(panel, {
    //         result: null,
    //         searchOptions: null,
    //         loadingError: params.error,
    //         loading: false,
    //         layerError: null
    //     });
    // },
    // [IDENTIFY_RECORD_LIST_LOADED](state, {...params}) {
    //     let panel = state.data.panels.identify;
    //     Object.assign(panel, {
    //         result: params.result,
    //         infoOptions: params.infoOptions,
    //         loadingError: null,
    //         loading: false
    //     });
    // },

    // FEATURE VIEWER
    [FEATURE_VIEWER_SET_LOADING](state, {...params }) {
        let panel = state.data.panels.featureviewer;
        panel.loading = params.loading;
    },
    [FEATURE_VIEWER_LOAD_ERROR](state, {...params }) {
        let panel = state.data.panels.featureviewer;
        Object.assign(panel, {
            result: null,
            loadingError: params.error,
            loading: false,
            layerError: null
        });
    },
    [FEATURE_VIEWER_LOADED](state, {...params }) {
        let panel = state.data.panels.featureviewer;
        Object.assign(panel, {
            result: params.result,
            options: params.options,
            loadingError: null,
            layerError: null,
            loading: false
        });
    },


    // FEEDBACK OPTIONS
    [FEEDBACKOPTIONS_INITIATE](state, {...params }) {
        let panel = state.data.panels.feedbackoptions;
        Object.assign(panel, {
            active: true,
            ...params
        });
    },
    [FEEDBACKOPTIONS_FINISHED](state, {...params }) {
        let panel = state.data.panels.feedbackoptions;
        Object.assign(panel, {
            active: false,
            ...params
        });
    },

    // BROADCASTING
    [SET_BROADCASTING_ENABLED](globalState, { enabled, ...params }) {
        const {state, ...rest} = params;
        globalState.data.global.broadcasting.active = enabled;
        if(state !== undefined) {
            globalState.data.global.broadcasting.state = state;
        }
    },
    [SET_BROADCASTING_STATE](globalState, { state, ...params }) {
        const {enabled, ...rest} = params;
        globalState.data.global.broadcasting.state = state;
        if(enabled !== undefined) {
            globalState.data.global.broadcasting.active = enabled;
        }
    },

    [SET_ACTION](state, {module, action }) {
        if(module in state) {
            let moduleState = state[module].data;
            moduleState = setState(moduleState, `action`, action);
            state[module].data = moduleState;
        }
    },
};

function isBackofficeModule(module) {
    return module ? !!module.match(new RegExp(`(${CITYHUB_MANAGE_SUFFIX}|central)$`, 'gi')) : false;
}

function customMergeDeepWithoutOverwrite(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Vue.set(target, key, {});
                customMergeDeepWithoutOverwrite(target[key], source[key]);
            } else {
                if(key in target)
                    continue;
                else{
                    Vue.set(target, key, source[key]);
                }
            }
        }
    }

    return customMergeDeepWithoutOverwrite(target, ...sources);
}

function receiveResponseIdentify(state, params, type) {
    const isVector = type === "vector";
    const requestIndex = !isVector ? (state.requests || []).findIndex((req) => req.reqId === params.reqId) : params.reqId;

    if (requestIndex !== -1) {
        // Handle data and vector responses
        const { configuration: config, requests } = state;
        let responses = state.responses || [];
        const isHover = (config && config.trigger ? config.trigger === "hover" : false); // Display info trigger

        // Filter un-queryable layer
        if (["exceptions", "error"].includes(type)) {
            const fltRequests = state.requests.filter((_, index) => index !== requestIndex);
            const fltResponses = state.responses.filter((_, index) => index !== requestIndex);
            const updateResponse = {
                response: null,
                exception: params[type],
                queryParams: params.requestParams,
                layerMetadata: params.layerMetadata,
                layer: params.layer
            };
            // Add response in same order it was requested
            responses[requestIndex] = updateResponse;
            let indexObj;
            if (!isHover && isIndexValid(state, responses, requestIndex, isVector)) {
                indexObj = { loaded: true };
            }
            Object.assign(
                state, {
                    ...(!isUndefined(indexObj) && indexObj),
                    responses: [...responses]
                }
            );
            return {
                ...state,
                responses: fltResponses,
                requests: fltRequests,
            };
        }

        if (!isVector) {
            const updateResponse = {
                response: params[type],
                queryParams: params.requestParams,
                layerMetadata: params.layerMetadata,
                layer: params.layer
            };
            if (isHover) {
                // Add response upon it is received
                responses = [...responses, updateResponse];
            } else {
                // Add response in same order it was requested
                responses[requestIndex] = updateResponse;
            }
        }

        let indexObj;
        if (isHover) {
            indexObj = { loaded: true, index: 0 };
        } else if (!isHover && isIndexValid(state, responses, requestIndex, isVector)) {
            indexObj = { loaded: true, index: requestIndex };
        }

        // Set responses and index as first response is received
        return Object.assign(
            state, {
                ...(isVector && { requests }),
                ...(!isUndefined(indexObj) && indexObj),
                responses: [...responses]
            }
        );
    }

    return state;
}

export default mutations;